import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FragnoListItem, FragnoListItemBlock } from 'fragno/react';
import WalletSectionCard from './WalletSectionCard';
import { authorizedToWorkStatus } from '../../reducers/countryWorkProfile';
import usWorkCardStyle from '../../style/components/profile/USWorkSectionCard.module.scss';

const WalletRightToWork = () => {
  const { t } = useTranslation();
  const { immigrationStatus, authorizedToWork, restrictionsOnWork } =
    useSelector((state) => state.countryWorkProfile);

  const authorizedToWorkLabel = (value) => {
    const status = authorizedToWorkStatus(value);
    if (status === 'yes') return t('shared.yes');
    if (status === 'no') return t('shared.no');
    return t('shared.unknown');
  };

  const restrictionsOnWorkLabel = (value) => {
    if (value === 'Yes') return t('shared.yes');
    if (value === 'No') return t('shared.no');
    return t('shared.unknown');
  };

  const rows = [
    {
      label: t('profile.immigrationStatus'),
      value: immigrationStatus ? t(`profile.basis.${immigrationStatus}`) : '',
    },
    {
      label: t('profile.authorizedToWork'),
      value: authorizedToWorkLabel(authorizedToWork),
    },
    {
      label: t('profile.restrictionsOnWork'),
      value: restrictionsOnWorkLabel(restrictionsOnWork),
    },
  ];

  const sectionId = 'wallet-right-to-work';

  return (
    <WalletSectionCard
      id={sectionId}
      title={t('profile.rightToWork')}
      noDivider
      className={usWorkCardStyle.card}
    >
      <FragnoListItemBlock aria-labelledby={sectionId}>
        {rows.map((row, index) => (
          <FragnoListItem
            key={row.label}
            icon="none"
            style={
              index < rows.length - 1
                ? {
                    paddingBottom: 'var(--spacing-md, 8px)',
                    // Matches $wallet-separator-color in _wallet-vars.scss —
                    // not a Nova token, same one-off WalletSectionCard's own
                    // titleRow divider uses.
                    borderBottom: '1px solid #dfdfdf',
                  }
                : undefined
            }
          >
            <span className="fragno-list-item__content">
              <span className="fragno-list-item__supporting-text">
                {row.label}
              </span>
              <span className="fragno-list-item__text">{row.value}</span>
            </span>
          </FragnoListItem>
        ))}
      </FragnoListItemBlock>
    </WalletSectionCard>
  );
};

export default memo(WalletRightToWork);
